/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EdictEntryResponse
 */
export interface EdictEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    clientId: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    caseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    debtorName: string;
    /**
     * 
     * @type {Date}
     * @memberof EdictEntryResponse
     */
    birthday: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    fileNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    sourceReference: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    counselorUserCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    caseNoteId: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    address: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    court: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    content: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    firstName: string;
    /**
     * 
     * @type {Date}
     * @memberof EdictEntryResponse
     */
    publishedDate: Date;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    postalCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictEntryResponse
     */
    city: string | null;
}

/**
 * Check if a given object implements the EdictEntryResponse interface.
 */
export function instanceOfEdictEntryResponse(value: object): value is EdictEntryResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('debtorName' in value) || value['debtorName'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('fileNumber' in value) || value['fileNumber'] === undefined) return false;
    if (!('sourceReference' in value) || value['sourceReference'] === undefined) return false;
    if (!('counselorUserCode' in value) || value['counselorUserCode'] === undefined) return false;
    if (!('caseNoteId' in value) || value['caseNoteId'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('court' in value) || value['court'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('publishedDate' in value) || value['publishedDate'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    return true;
}

export function EdictEntryResponseFromJSON(json: any): EdictEntryResponse {
    return EdictEntryResponseFromJSONTyped(json, false);
}

export function EdictEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdictEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'caseNumber': json['caseNumber'],
        'debtorName': json['debtorName'],
        'birthday': (json['birthday'] == null ? null : new Date(json['birthday'])),
        'fileNumber': json['fileNumber'],
        'sourceReference': json['sourceReference'],
        'counselorUserCode': json['counselorUserCode'],
        'caseNoteId': json['caseNoteId'],
        'address': json['address'],
        'court': json['court'],
        'content': json['content'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'publishedDate': (new Date(json['publishedDate'])),
        'street': json['street'],
        'postalCode': json['postalCode'],
        'city': json['city'],
    };
}

export function EdictEntryResponseToJSON(json: any): EdictEntryResponse {
    return EdictEntryResponseToJSONTyped(json, false);
}

export function EdictEntryResponseToJSONTyped(value?: EdictEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'caseNumber': value['caseNumber'],
        'debtorName': value['debtorName'],
        'birthday': value['birthday'] == null ? value['birthday'] : `${value['birthday'].getFullYear()}-${String(value['birthday'].getMonth()+1).padStart(2,'0')}-${String(value['birthday'].getDate()).padStart(2,'0')}`,
        'fileNumber': value['fileNumber'],
        'sourceReference': value['sourceReference'],
        'counselorUserCode': value['counselorUserCode'],
        'caseNoteId': value['caseNoteId'],
        'address': value['address'],
        'court': value['court'],
        'content': value['content'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'publishedDate': `${value['publishedDate'].getFullYear()}-${String(value['publishedDate'].getMonth()+1).padStart(2,'0')}-${String(value['publishedDate'].getDate()).padStart(2,'0')}`,
        'street': value['street'],
        'postalCode': value['postalCode'],
        'city': value['city'],
    };
}

